export let columnOptions = [
  {
    class_: "100",
    width: { 0: 100 },
    columns: 1,
  },
  {
    class_: "1-2",
    width: { 0: 50, 1: 50 },
    columns: 2,
  },
  {
    class_: "30-70",
    width: { 0: 30, 1: 70 },
    columns: 2,
  },
  {
    class_: "70-30",
    width: { 0: 70, 1: 30 },
    columns: 2,
  },
  {
    class_: "1-3",
    width: { 0: 33.333, 1: 33.333, 2: 33.333 },
    columns: 3,
  },
  {
    class_: "25-25-50",
    width: { 0: 25, 1: 25, 2: 50 },
    columns: 3,
  },
  {
    class_: "50-25-25",
    width: { 0: 50, 1: 25, 2: 25 },
    columns: 3,
  },
  {
    class_: "25-50-25",
    width: { 0: 25, 1: 50, 2: 25 },
    columns: 3,
  },
  // {
  //   class_: "1-4",
  //   width: { 0: 25, 1: 25, 2: 25, 3: 25 },
  //   columns: 4,
  // },
  // {
  //   class_: "1-5",
  //   width: { 0: 20, 1: 20, 2: 20, 3: 20 },
  //   columns: 5,
  // },
];
